angular.module('bribac.translations.sv', [])

  .constant('SV_TRANSLATIONS', {

    today: "Idag",
    scheduled_test: "Schemalagt test",
    optional_test: "Frivilligt alkoholprov",

    bacUnits: {
      short: {
        BRAC: 'brAC',
        BAC_PER_MILLE: '‰',
        BAC_PERCENT: '%'
      },
      long: {
        BRAC: 'brAC',
        BAC_PER_MILLE: '‰ (per mille)',
        BAC_PERCENT: '% (percent)'
      }
    },

    boolean: {
      yes: 'Ja',
      no: 'Nej',
    },

    components: {
      agentDetails: {
        role: 'Roll',
        fullAddress: 'Adress',
        fullAddressValue: '{{address}}, {{postalCode}}, {{city}}',
        phone: 'Telefonnummer',
        email: 'E-postadress',
        status: 'Status',
      },

      agentEditor: {
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        phone: 'Telefonnummer (inkluderat landskod)',
        email: 'E-postadress',
        streetAddress: 'Gatuadress',
        postalCode: 'Postnummer',
        city: 'Stad',
        organization: 'Organisation',
        roleHeading: 'Roll',
        notAllowedToChangeRole: 'Du har inte tillåtelse att ändra denna administratörens roll.',
        systemLanguageHeading: 'Systemets språk',
        groupsHeading: 'Grupper',
        mustChooseOrganizationBeforeGroups: 'Du behöver välja en organisation innan du kan välja grupper.',
        thisGroupDoesntHaveAnySubGroups: 'Denna gruppen har inga undergrupper.',
        agentSettingsHeading: 'Administratör inställningar',
        notifyAgentUsing: 'Meddela administratör med…',
        calibrationNotification: "Få kalibreringsmeddelanden",
        scheduleEndNotification: "Ta emot meddelanden om att schemat är slut",
        deleteAgent: 'TA BORT',
      },

      collapsingBox: {
        expand: 'Fäll ut',
        collapse: 'Fäll ihop',
      },

      ibacDetails: {
        macAddress: 'MAC adress',
        lastUsed: 'Senast använd',
        lastCalibrated: 'Senast kalibrerad',
        cycles: 'Cykler',
        cyclesLeftUntilMaintenance: 'Cykler kvar tills underhåll',
        daysLeftUntilMaintenance: 'Dagar kvar tills underhåll',
        showDetails: 'Visa detaljer',
        lastLocation: 'Senaste platsen',
        locationNotAvailable: 'Senaste platsen är inte tillgänglig',
        status: 'Status',
        editIbac: 'Ändra iBac',
        batteryCharge: 'Batteriladdning',
        batteryEstimation: 'Återstående uppskattning av estimerad driftstid',
        assignedToSubject: 'Tilldelad användaren'
      },

      ibacEditor: {
        macAddress: 'MAC adress',
        organization: 'Organisation',
        ibac: 'iBac'
      },

      inputFile: {
        selectImage: 'Välj Bild',
        imageToUpload: 'Bild att ladda upp',
        selectCsv: 'CSV fil att ladda upp'
      },

      csvUpload: {
        selectCsv: 'Välj CSV',
        csvToUpload: 'CSV att ladda upp'
      },

      mainGroupEditor: {
        name: 'Namn',
      },

      mainGroupOverview: {
        thereAreNoSubGroupsInName: 'Det finns inga undergrupper i {{name}}.',
        noGroups: 'Det finns inga grupper.'
      },

      mainMenu: {
        home: 'Hem',
        add: 'Lägg till',
        templates: 'Mallar',
        groups: 'Grupper',
        search: 'Sök',
        myProfile: 'Min profil',
        ibac: 'iBac',
        reports: 'Rapporter',
        organizations: 'Organisationer',
        notes: 'Anteckningar',
        logOut: 'Logga ut',
        alerts: 'Varningar',
        documentation: 'Dokumentation'
      },

      mainGroupSubGroupPicker: {
        noGroupsInOrganization: "Det finns inga grupper i organisationen."
      },

      messageEditorModal: {
        sendSmsToFullName: 'Skicka SMS till {{fullName}}',
        theSmsWasSentToFullName: 'SMS:et har skickats till {{fullName}}',
        characters: 'tecken',
        cancel: 'Avbryt',
        close: 'Stäng',
        sendTheSms: 'Skicka SMS:et',
      },

      samplesChartModal: {
        samplesForFullName: 'Alkoholprover för {{fullName}}',
        chosenDateFrom: 'Valda datum från',
        chosenDateTo: 'Valda datum till',
        rangeButtons: {
          lastWeek: 'Förra veckan',
          lastMonth: 'Förra månaden',
          lastSixMonths: 'Senaste sex månaderna',
          lastYear: 'Förra året',
        },
        typeButtons: {
          mood: 'Mående',
          failedFRS: 'Misslyckad FRS',
          failedAlcohol: 'Misslyckad Alkohol',
          missedSchedule: 'Missat Schemalagt test',
        },
        back: 'Tillbaka'
      },

      datePickerPopup: {
        reset: 'Återställa',
        today: 'I dag',
        done: 'Gjort'
      },

      noteEditor: {
        text: 'Text',
      },

      optionalSampleOverview: {
        passedOnDate: 'Godkänd {{dateCreated | date:"short"}}',
        failedOnDate: 'Misslyckades {{dateCreated | date:"short"}}',
      },

      organizationDetails: {
        organizationalNumber: 'Organisations nummer',
        licenseType: 'Licens typ',
        bacUnit: 'BAC enhet',
        settings: 'Inställningar',
        messageSupport: 'Kan skicka meddelanden till användare',
        noteSupport: 'Kan lägga till anteckningar på användare',
        randomTests: 'Kan skapa/använda scheman med slumpmässiga tester',
        roleManagement: 'Kan definiera olika administrativa roller',
        faceRecognition: 'Kan använda automatisk ansiktsigenkänning',
        createSubjectSummaryReport: 'Kan generera en sammanfattande rapport om användare',
        status: 'Status',
      },

      organizationEditor: {
        name: 'Namn',
        organizationalNumber: 'Organisations nummer',
        bacUnitHeading: 'BAC enhet',
        licenseTypeHeading: 'Licens typ',
        settingsHeading: 'Inställningar',
        cantConfigSettingsForNewOrg: 'Du kan inte konfigurera inställningarna samtidigt som du skapar en ny organisation.',
        messageSupport: 'Kan skicka meddelanden till användare',
        noteSupport: 'Kan lägga till anteckningar på användare',
        randomTests: 'Kan skapa/använda scheman med slumpmässiga tester',
        roleManagement: 'Kan definiera olika administrativa roller',
        faceRecognition: 'Kan använda automatisk ansiktsigenkänning',
        createSubjectSummaryReport: 'Kan generera en sammanfattande rapport om användare',
        notifyWhen: 'Notifiera när iBAC har',
        leftUntilCalibration: 'Kvar tills kalibrering',
        notifyWhenCalibrationDaysLeft: 'Notifiera när iBAC har {{value}} dagar kvar tills kalibrering',
        notifyWhenCalibrationCyclesLeft: 'Notifiera när iBAC har {{value}} cykler kvar tills kalibrering',
        cycles: 'Cykler',
        days: 'Dagar',
        hasToBeNumber: 'Måste vara nummer',
        higherThanZero: 'Måste vara större värde än noll',
        notifyEndScheduleDaysLeft: 'Meddela när schemat slutar i',
        notifyWhenEndOfScheduleDaysLeft: 'Meddela när schemat har {{value}} dag(ar) kvar att sluta'
      },

      ruleSetDetails: {
        alcoholLimit: 'Promillegräns',
        testExpiresAfter: 'Testet löper ut efter',
        testExpiresAfterSecondsValue: '{{testExpiresAfterSeconds / 60}} min',
        showResultsToSubject: 'Visa resultat för användaren',
        showCalibrationAlert: "Visa kalibreringsvarningar",
        notifyMonitorsWhen: 'Meddela administratör när…',
        notifySubjectsUsing: 'Meddela användaren med…',
        gpsRequired: 'GPS-plats krävs'
      },

      ruleSetEditor: {
        name: 'Namn',
        testExpiresAfterSecondsUnit: 'sekunder',
        saveTemplateCopy: 'Spara en kopia som en mall',
        templatesReuse: 'Mallar kan återanvändas med andra användare.',
        alcoholLimit: 'Promillegräns',
        cancel: 'Avbryt',
        saveSettings: 'Spara inställningar',
        savingSettings: 'Sparar inställningar',
        testExpiresAfter: 'Testet löper ut efter',
        showResultsToSubject: 'Visa resultat för användaren',
        showCalibrationAlert: 'Visa kalibreringsvarningar',
        notifyMonitorsWhen: 'Meddela administratör när…',
        notifySubjectsUsing: 'Meddela användaren med…',
        gpsRequired: 'GPS-plats krävs',
        deleteTestDataAfterDays: 'Radera testdata efter (dagar)',
        deleteTestDataAfterDays_doNotDelete: 'Aldrig',
      },

      scheduleDetails: {
        weekdays: 'Veckodagar',
        randomTests: 'Slumpmässiga tester',
      perDay: 'Per dag',
        betweenTimes: 'Mellan tiderna',
        fixedTests: 'Schemalagda tester',
      },

      scheduleEditor: {
        whichDaysHeading: 'Vilka dagar att testa på',
        randomTestHeading: 'Slumpmässigt test',
        randomTestsWillOccurBetweenTheseTimes: 'Slumpmässiga test kommer att inträffa mellan',
        scheduledTestHeading: 'Schemalagt test',
        moodQuestionHeading: 'Frågor om mående',
        addMoodQuestionButton: 'Lägg till en fråga om mående',
        addAnotherMoodQuestionButton: 'Lägg till en annan fråga',
        howManyTestsADayAndWhichTimes: 'Hur många tester om dagen och vilka tider?',
        removeTimeButton: 'Ta bort',
        addTimeButton: 'Lägg till en tid',
        cancelButton: 'Avbryt',
        saveButton: 'Spara schemat',
        savingButton: 'Sparar schemat…',
        labels: {
          name: 'Namn',
          template: 'Spara en kopia som mall',
          templateDescription: 'Mallar kan återanvändas med andra användare.',
          maxRandomTestsPerDay: 'Max antal slumpmässiga tester om dagen',
          zeroTestDescription: '0 = inget slumpmässigt test krävs',
          earliest: 'Tidigast',
          latest: 'Senast',
          repeatCycle: 'Upprepa varje',
          repeatWeek: 'Vecka',
          repeatWeeks: 'Veckor'
        },
      },

      schedulePeriodDetails: {
        schedule: 'Schema',
        activePeriod: 'Aktiv period',
        period: '{{startDate | date:"shortDate"}} - {{endDate | date:"shortDate"}}',
      },

      schedulePeriodEditor: {
        cancelButton: 'Avbryt',
        saveButton: 'Spara schemat',
        savingButton: 'Sparar schemat…',
        labels: {
          startDate: 'Startdatum',
          endDate: 'Slutdatum',
        },
        question: {
          deleteSchedule: 'Vill du verkligen ta bort schemat från användaren?',
          recreateTests: 'Vill du återanvända dagens schemalagda tester?',
          deleteTests: 'Vill du radera dagens schemalagda tester?'
        }
      },

      externalMonitorDetails: {
        labels: {
          name: 'Namn',
          phone: 'Telefonnummer',
          email: 'E-postadress',
          fillAtleastOne: 'Fyll i minst ett fält'
        }
      },

      externalMonitorEditor: {
        phone: 'Telefonnummer (inkluderat landskod)',
        cancelButton: 'Avbryt',
        saveButton: 'Spara extern övervakare'
      },

      searchForm: {
        submitButton: 'Sök',
        labels: {
          query: 'Sök i iBac',
        },
      },

      subGroupEditor: {
        labels: {
          name: 'Name',
        },
      },

      subGroupOverview: {
        noSubjectsInSubGroup: 'Det finns inga användare i {{name}}.',
      },

      subjectDetails: {
        group: 'Grupp',
        subGroupInMainGroup: ' i ',
        fullAddress: 'Adress',
        fullAddressValue: '{{address}}, {{postalCode}}, {{city}}',
        phone: 'Telefonnummer',
        email: 'E-postadress',
        timeZone: 'Tidszon',
        highlighted: 'Extra bevakning',
        hasInsurance: 'Har försäkring',
        ssn: 'Personnummer',
        status: 'Status',
        photo: 'Användarens bild',
        createdDate: 'Skapat på'
      },

      subjectEditor: {
        groupHeading: 'Grupp',
        mainGroupHeading: 'Huvudgrupp',
        subGroupHeading: 'Undergrupp',
        chooseMainGroupBeforeSubGroup: 'Välj en huvudgrupp först.',
        systemLanguageHeading: 'Systemets språk',
        ruleSetHeading: 'iBac inställningar',
        editRuleSetButton: 'Ändra',
        removeRuleSetButton: 'Ta bort',
        cancelRuleSetButton: 'Avbryt',
        useRuleSetButton: 'Använd inställningarna',
        subjectDoesntHaveAnyRuleSets: 'Användaren har inga iBac inställningar.',
        addNewRuleSetButton: 'Lägg till nya inställningar',
        addRuleSetFromTemplateButton: 'Lägg till inställningar från en mall',
        addNewRuleSetHeading: 'Lägg till nya iBac inställningar',
        addRuleSetFromTemplateHeading: 'Lägg till iBac inställningar från en mall',
        editTheCurrentRuleSetHeading: 'Ändra de nuvarande iBac inställningarna',
        schedulesHeading: 'Scheman',
        editScheduleButton: 'Ändra',
        removeScheduleButton: 'Ta bort',
        subjectDoesntHaveAnySchedules: 'Användaren har inga scheman.',
        addNewScheduleButton: 'Lägg till ett nytt schema',
        addScheduleFromTemplateButton: 'Lägg till ett schema från en mall',
        addNewScheduleHeading: 'Lägg till ett nytt schema',
        addScheduleFromTemplateHeading: 'Lägg till ett schema från en mall',
        editingSchedule: 'Ändrar schemat {{name}}',
        saveSubjectButton: 'Spara inställningar',
        savingSubjectButton: 'Sparar inställningar…',
        crisisAgentHeading: 'Kris administratör',
        externalMonitorsHeading: 'Externa övervakare',
        addNewExternalMonitorButton: 'Lägg till nya extern övervakare',
        editExternalMonitor: 'Redigera en befintlig extern behandlare/kontaktperson',
        deleteExtMonitorQuestion: 'Vill du verkligen ta bort den externa övervakare från användar?',
        subjectNoExternalMonitors: '{{firstName}} har inga externa övervakare.',
        alertSelectOnlyFiveImages: 'Du kan bara välja 5 bilder',
        onlyFiveImagesAllowed: 'Max 5 bilder tillåtna',
        labels: {
          firstName: 'Förnamn',
          lastName: 'Efternamn',
          ssn: 'Personnummer',
          address: 'Gatuadress 1',
          address1: 'Gatuadress 2',
          postalCode: 'Postnummer',
          city: 'Stad',
          phone: 'Mobil telefonnummer (inkluderat landskod)',
          email: 'E-postadress',
          timeZone: 'Tidszon',
          highlighted: 'Extra bevakning',
          pauseScheduledTests: 'Pausa schemalagda tester',
          showInactiveOrganization: 'Visa inaktiva organisationer',
          secondaryPhone: 'Andra telefonnummer',
          gender: 'Kön',
          dateOfBirth: 'Födelsedatum',
          employer: 'Arbetsgivarens namn',
          occupation: 'Yrke',
        },
        assignedIbac: 'Tilldelad iBac',
        addInsuranceData: 'Lägg till försäkringsinformation',
        insuranceDataHeading: 'Försäkringsinformation',
        insuranceProviderHeading: 'Försäkringsgivare',
        selectInsuranceProvider: 'Välj försäkringsgivare',
        insuranceCompanyHeading: 'Försäkringsbolag',
        selectInsuranceCompany: 'Välj försäkringsbolag',
        insuranceSubscriberHeading: 'Försäkringstagare',
        selectInsuranceSubscriber: 'Välj försäkringstagare',
        editTheCurrentInsuranceHeading: 'Edit the insurance',
        subjectAsSubscriber: "Subject is Subscriber"
      },

      subjectOverview: {
        highlighted: 'Extra bevakning',
        scheduledTestsArePaused: 'Schemalagda tester är pausade',
        sendMessageButton: 'Skicka meddelande',
        showProfileButton: 'Visa profilen',
      },

      testDetails: {
        testPassed: 'Prov avklarat',
        testHasNotStartedYet: 'Testet har inte startat ännu',
        startsOn: 'Startar',
        expiresOn: 'Löper ut',
        allowedAlcoholValue: 'Tillåtet alkohol värde',
        submittedAlcoholValue: 'Inlämnat alkohol värde',
        testOpen: 'Test oavslutat',
        waitingForSampleToBeHandedIn: 'väntar på att ett prov ska lämnas in',
        testFailed: 'Testet misslyckades',
        noSampleWasHandedIn: 'inget prov lämnades in',
        theSampleExceededTheAllowedAlcoholLimit: 'provet överskred den tillåtna alkoholgränsen',
        sampleTakenOn: 'Prov taget',
        sampleReceivedAt: 'Testresultatet kom servern tillhanda',
        deviceColor: 'Färg på enhet',
        showLocationOnMap: 'Visa plats på karta',
        hideLocationOnMap: 'Dölj plats på karta',
        showProfileButton: 'Visa profilen',
        locationNotAvailable: 'Platsen är inte tillgänglig',
        feeling: 'Känsla',
        faceRecognition: {
          title: 'Ansiktsigenkänning',
          result: 'Resultat',
          createdBy: 'Skapad av',
          failReasonTitle: 'Orsak till misslyckande',
          left: 'Vänster',
          right: 'Höger',
          profile: 'Profil',
          failReson: '{{side}} foto - {{error}}'
        },
        faceRecognitionCheckResult: 'Resultat av ansiktsigenkänning',
        faceRecognitionCheckCreatedBy: 'Ansiktsigenkänning skapad av',
        question: 'Frågor om mående',
        answer: 'Svara',
        RED: "röd",
        BLUE: "blå",
        PINK: "rosa",
        YELLOW: "gul",
        GREEN: "grön",
        RÖD: "röd",
        BLÅ: "blå",
        ROSA: "rosa",
        GUL: "GUL",
        GRÖN: "grön",
        // optionalTest: 'Detta prov togs utan ett schemalagt eller slumpmässigt test.',
        // theSampleWasHandedInOutsideOfTheAllowedLocation: 'provet lämnades in utanför den tillåtna platsen',
      },

      testOverview: {
        opensOnDate: 'Testet är planerat att börja {{opensOnDate | date:"short"}}',
        passedOnDate: 'Godkänd {{dateCreated | date:"short"}}',
        failedOnDate: 'Misslyckades {{dateCreated | date:"short"}}',
        expiresOnDate: 'Förföll {{expiresOnDate | date:"short"}}',
        pendingNoSampleHasBeenHandedInYet: 'Väntar, inget prov har lämnats in ännu',
        failedNoSampleWasHandedIn: 'Misslyckades, inget prov lämnades in',
      },

      whenLoaded: {
        loading: 'Laddar…',
      },

      activation: {
        activateButton: 'AKTIVERA',
        deactivateButton: 'AVAKTIVERA',
      },
      imageMultiSelect: {
        notFound: 'Ej funnen',
        selectAll: "Välj alla",
        unselectAll: "Avmarkerar",
      },
      boostImageEditor: {
        header: 'Boost bilder'
      },
      moodQuestionComponent: {
        addMoodQuestionButton: 'Lägg till en måendefråga',
        saveQuestion: 'Spara',
        question1: 'Hur mår du idag?',
        question2: 'Har du sovit ordentligt?',
        question3: 'Känner du oro, beskriv din känsla',
        question4: 'Beskriv något bra idag , vad som helst',
        custom: "Anpassad:"
      },
      inactiveDays: {
        heading: 'Inaktiva dagar',
        addInactiveDays: 'Lägg till inaktiva dagar',
        setInactiveRange: 'Ange intervall för inaktiva dagar',
        dateRangeFrom: 'Datumintervall från',
        dateRangeTo: 'Datumintervall till',
        selectedDate: 'Valt datum',
        saveInactiveDays: 'Spara inaktiva dagar',
        confirmSetDateActive: 'Vill du ange datum som aktivt?',
        confirmSetDateInactive: 'Vill du ange datum som inaktiv?'
      }
    },

    EXCEPTIONS: {
      MULTIPLE_OPEN_TESTS: '{{firstName}} har redan ett öppet test.'
    },

    "Internal Server Error":"Ett fel uppstod. Försök igen och kontakta support om problemet kvarstår",
    formErrors: {
      "invalidNPI": "NPI måste ha minst 3 siffror.",
      invalidFields: "Vissa uppgifter är felaktiga eller saknas. Kontrollera din inmatning",
      required: 'Nödvändig',
      minlength: 'Får som minst vara {{minLength}} tecken',
      maxLength: 'Får som mest vara {{maxLength}} tecken',
      invalidEmailAddress: 'Ogiltig e-postadress',
      invalidPhoneNumber: 'Telefonnumret får bara innehålla siffror och mellanslag och måste börja med en landskod. Exempel: +46 123 456 789',
      invalidPhoneNumberInsuranceCompany: 'Telefonnumret får bara innehålla siffror och mellanslag och måste INTE börja med \+. Exempel: 46123 456 789, 123456789',
      invalidPassword: 'Lösenordet måste vara minst 8 tecken långt och får bara innehålla bokstäver från A till Z och siffror från 0 till 9.',
      invalidDateOfBirth: 'Födelsedatumet måste vara i formatet ÅÅÅÅ-MM-DD.',
      invalidMacAddress: 'Ogiltigt MAC-adressformat',
      invalidSSN: 'Personnummer får enbart innehålla siffror. Exempel: 1234567890',
      outsideInterval: 'Minimum tiden är 5 minuter och max-tiden är 720 minuter.',
      invalidPhoto: 'Bildformat stöds ej.',
      hasToBeNumber: 'Alkoholgränsvärdet måste ha ett värde',
      minBacLimitValue: 'Ange värdet över eller lika med {{minBacLimitValue}}.',
      maxBacLimitValue: 'Ange värdet nedan eller lika med {{maxBacLimitValue}}.',
      earliestAfterLatest: 'Tidigaste tid kan inte vara senast',
      numberRequired: 'Ange värdet 6-siffor nummer',
      unauthorized: 'Obehörig',
      unknownError: 'Okänt fel',
      subjectLoginError:'Klient /Användar konton är inte tillåtna att använda webb webbgränssnitt'
    },

    formSuccess: {
      savedUser: '{{name}} sparat. Ett aktiveringsmeddelande har skickats till {{email}}.',
    },

    licenseTypes: {
      PRO: 'Pro',
      'PRO GROUP': 'Pro grupp'
    },

    locales: {
      'en': 'Engelska',
      'sv': 'Svenska',
      'ko': 'Koreanska'
    },

    months: {
      'JAN': 'Januari',
      'JAN.short': 'Jan',
      'FEB': 'Februari',
      'FEB.short': 'Feb',
      'MAR': 'Mars',
      'MAR.short': 'Mar',
      'APR': 'April',
      'APR.short': 'Apr',
      'MAY': 'Maj',
      'MAY.short': 'Maj',
      'JUN': 'Juni',
      'JUN.short': 'Jun',
      'JUL': 'Juli',
      'JUL.short': 'Jul',
      'AUG': 'Augusti',
      'AUG.short': 'Aug',
      'SEP': 'September',
      'SEP.short': 'Sept',
      'OCT': 'Oktober',
      'OCT.short': 'Okt',
      'NOV': 'November',
      'NOV.short': 'Nov',
      'DEC': 'December',
      'DEC.short': 'Dec'
    },

    notificationEvents: {
      testPassed: 'Test godkänt',
      testFailed: 'Test misslyckat',
      optionalTestPassed: 'Valfritt test godkänt',
      optionalTestFailed: 'Valfritt test misslyckades',
      testExpired: 'Test löper ut',
      frs: 'Har automatisk ansiktsigenkänning resultat'
    },

    notificationMethods: {
      sms: 'SMS',
      email: 'E-post',
      push: 'Push meddelande',
    },

    units: {
      minute: {
        short: 'min',
        long: 'minute',
      },
    },

    roles: {
      ROLE_SUPER_ADMIN: 'Superadministratör',
      ROLE_ADMIN: 'Administratör',
      ROLE_GROUP_ADMIN: 'Gruppadministratör',
      ROLE_SUBJECT: 'Användare',
    },

    views: {
      404: {
        heading: 'Felkod 404, sidan kunde inte hittas',
        homeLink: 'Gå till startsidan',
      },

      addAgent: {
        heading: 'Lägg till administratör',
        save: 'Spara inställningar',
        saving: 'Sparar inställningar…',
        addedHeading: 'Tillagda administratörer',
        nothingAdded: 'Du har inte lagt till några nya administratörer.',
      },

      addGroup: {
        mainGroupHeading: 'Lägg till huvudgrupp',
        saveMainGroup: 'Spara huvudgruppen',
        savingMainGroup: 'Sparar huvudgruppen…',
        addedMainGroupsHeading: 'Tillagda huvudgrupper',
        noMainGroupsAdded: 'Du har inte lagt till några huvudgrupper.',
        subGroupHeading: 'Lägg till undergrupp',
        chooseMainGroupToAddSubGroups: 'Välj den huvudgrupp som du vill lägga till undergrupper i.',
        saveSubGroup: 'Spara undergruppen',
        savingSubGroup: 'Sparar undergruppen…',
        addedSubGroupsInMainGroupHeading: 'Tillagda undergrupper i {{name}}',
        noSubGroupsAdded: 'Du har inte lagt till några undergrupper.',
      },

      addIbac: {
        heading: 'Lägg till iBac',
        save: 'Spara iBac',
        saving: 'Sparar iBac…',
        addedHeading: 'Tillagda iBac enheter',
        nothingAdded: 'Du har inte lagt till några nya iBac enheter.',
      },

      addOrganization: {
        heading: 'Lägg till organisation',
        save: 'Spara organisationen',
        saving: 'Sparar organisationen…',
        addedHeading: 'Tillagda organisationer',
        nothingAdded: 'Du har inte lagt till några nya organisationer.',
      },

      addRuleSet: {
        heading: 'Lägg till inställningsmall',
        addedHeading: 'Tillagda inställningsmallar',
        nothingAdded: 'Du har inte lagt till några nya inställningsmallar.',
      },

      addSchedule: {
        heading: 'Lägg till schemaläggningsmall',
        addedHeading: 'Tillagda schemaläggningsmallar',
        nothingAdded: 'Du har inte lagt till några nya schemaläggningsmallar.',
      },

      addSubject: {
        heading: 'Lägg till användare',
        addedHeading: 'Tillagda användare',
        nothingAdded: 'Du har inte lagt till några nya användare.',
      },

      addInsuranceProvider: {
        heading: 'Lägg till försäkringsgivare',
        addedHeading: 'Tillagda försäkringsgivare',
        nothingAdded: 'Du har inte lagt till några nya försäkringsgivare.',
      },

      addInsuranceSubscriber: {
        heading: 'Lägg till försäkringstagare',
        addedHeading: 'Tillagda försäkringstagare',
        nothingAdded: 'Du har inte lagt till några nya försäkringstagare.',
      },

      addInsuranceCompany: {
        heading: 'Lägg till försäkringsbolag',
        addedHeading: 'Tillagda försäkringsbolag',
        nothingAdded: 'Du har inte lagt till några nya försäkringsbolag.',
      },

      add: {
        peopleOrGroupsHeading: 'Lägg till nya personer eller grupper',
        planTemplatesHeading: 'Lägg till nya planmallar',
        organizationsHeading: 'Lägg till nya organisationer och iBac enheter',
        agent: 'Administratör',
        subject: 'Användare',
        insuranceProvider: 'Försäkringsgivare',
        insuranceSubscriber: 'Försäkringstagare',
        insuranceCompany: 'Försäkringsbolag',
        group: 'Grupp',
        schedule: 'Schemaläggningsmall',
        settings: 'Inställningsmall',
        organization: 'Organisation',
        ibac: 'iBac'
      },

      upload: {
        subjects: 'Ladda upp CSV med personer',
        subjectsHeading: 'Ladda upp CSV med personer'
      },

      alerts: {
        noAlerts: 'Det finns inga {{filterToPrint}}'
      },

      editAgent: {
        heading: 'Ändra profilinställningar för {{fullName}}',
        save: 'Spara inställningar',
        saving: 'Sparar inställningar…',
      },

      editMainGroup: {
        heading: 'Ändrar på {{name}}',
        save: 'Spara huvudgruppen',
        saving: 'Sparar huvudgruppen…',
      },

      editOrganization: {
        heading: 'Ändrar på {{name}}',
        save: 'Spara organisationen',
        saving: 'Sparar organisationen…',
      },

      editRuleSet: {
        heading: 'Ändrar på {{name}}',
      },

      editSchedulePeriod: {
        heading: 'Ändrar på {{schedulePeriod}} för {{subject}}',
      },

      editSchedule: {
        heading: 'Ändrar på {{name}}',
      },

      editSubGroup: {
        heading: 'Ändrar på {{name}}',
        save: 'Spara undergruppen',
        saving: 'Sparar undergruppen…',
      },

      editSubject: {
        heading: 'Ändrar på {{fullName}}',
      },

      editIbac: {
        heading: 'Ändrar på {{macAddress}}',
        cancel: 'Avbryt',
        saveEvent: 'Spara händelse',
        addNewEvent: 'Lägg till en ny händelse',
        editEvent: 'Redigera händelse',
        removeEvent: 'Ta bort händelsen',
        activate: 'Aktivera',
        deactivate: 'Avaktiverade',
        activateAt: 'Aktivera',
        deactivateAt: 'Avaktiverade',
        setEventAndType: 'Ställ in händelsetyp och tid',
        noEvents: 'Inga planerade händelser',
        deleteEventQuestion: 'Vill du verkligen ta bort den här händelsen?',
        eventsOfIbac: 'iBac-aktiviteter',
        eventType: 'Event typ',
        eventTime: 'Händelsetid',
        required: 'krävs'
      },

      forgotPassword: {
        heading: 'Glömt lösenord',
        resetEmailSentTitle: 'Begäran mottagen',
        resetEmailSentDescription: 'Ett e-postmeddelande med en länk för att återställa lösenordet har skickats till {{email}}.',
        labels: {
          email: 'E-post',
        },
        submitButton: 'Begär nytt lösenord',
        backToLogin: 'Tillbaka till inloggning',
      },

      home: {
        filtersHeading: 'Vilka grupper vill du se?',
        allGroupsFilter: 'Alla grupper',
        highlightedSubjectsFilter: 'Användare med extra bevakning',
        noHighlightedSubjects: 'Det finns inga användare med extra bevakning i grupperna du övervakar.',
        inactiveSubjectsFilter: 'Inaktiva användare',
        noInactiveSubjects: 'Det finns inga användare med Inaktiva i grupperna du övervakar.'
      },

      listAgents: {
        heading: 'Administratörer',
      },

      listOrganizations: {
        heading: 'Organisationer',
        noActiveOrganizations: 'Inga aktiva organisationer.',
        noInactiveOrganizations: 'Inga inaktiva organisationer.',
        sortByName: 'Sortera organisationer efter namn'
      },

      listRuleSets: {
        heading: 'Inställningsmallar',
        noRuleSets: 'Inga inställningsmallar'
      },

      listSchedules: {
        heading: 'Schemaläggningsmallar',
        noSchedules: 'Inga schemaläggningsmallar'
      },

      listSubjects: {
        heading: 'Användare',
      },

      listIbacs: {
        heading: 'iBac enheter',
        noIbacs: 'Inga iBac-enheter.',
        noActiveIbacs: 'Inga aktiva iBac-enheter.',
        noInactiveIbacs: 'Inga inaktiva iBac-enheter.',
        noTamperedIbacs: 'Inga manipulerade iBac-enheter.',
      },

      listAlerts: {
        heading: 'Översikt över {{filter}}',
        dateHeading: 'Datum',
        startDate: 'Startdatum',
        endDate: 'Slutdatum',
        eventTypeHeading: 'Event typ',
        subjectNameHeading: 'Ämnes namn',
        groupHeading: 'Grupp',
        ibacHeading: 'iBac enhet',
        noAll: 'varningar eller överträdelser'
      },

      login: {
        heading: 'Välkommen',
        labels: {
          email: 'E-post',
          password: 'Lösenord',
        },
        submitButton: 'Logga in',
        forgotPassword: 'Glömt lösenord',
        rememberMe: 'Kom ihåg mig',
      },

      reports: {
        download: 'Ladda ner',
        processing: 'Bearbetning...',
        groups:{
          subject:'Användare',
          ibac:'iBac'
        }
      },

      search: {
        heading: 'Sök',
        domains: {
          everything: 'Allt',
          subjects: 'Användare',
          agents: 'Administratörer',
          mainGroups: 'Huvudgrupper',
          subGroups: 'Undergrupper',
          organizations: 'Organisationer'
        },
        subjectsHeading: 'Användare',
        noSubjectsFound: 'Inga användare hittades.',
        agentsHeading: 'Administratörer',
        noAgentsFound: 'Inga administratörer hittades.',
        mainGroupsHeading: 'Huvudgrupper',
        noMainGroupsFound: 'Inga huvudgrupper hittades.',
        subGroupsHeading: 'Undergrupper',
        noSubGroupsFound: 'Inga undergrupper hittades.',
        organizationsHeading: 'Organisationer',
        noOrganizationsFound: 'Inga organisationer hittades.'
      },

      setPassword: {
        invalidTokenHeading: 'Ogiltigt lösenordstoken.',
        goToLogin: 'Gå till inloggning',
        heading: 'Välj lösenord',
        labels: {
          password: 'Lösenord',
          confirmPassword: 'Bekräfta lösenord'
        },
        passwordsDontMatch: 'Lösenorden stämmer inte överens.',
        submitButton: 'Spara',
        passwordSavedHeading: 'Lösenordet sparat.',
        continueButton: 'Fortsätt',
        subjectCanNowUseTheMobileApp: 'Du kan nu använda mobilappen.',
      },

      singleAgent: {
        editAgent: 'Ändra administratören',
        editYourself: 'Profilinställningar',
      },

      singleMainGroup: {
        addSubGroups: 'Lägg till undergrupper',
        editMainGroup: 'Ändra huvudgruppen',
        mainGroupDoesntHaveAnySubGroups: 'Denna huvudgruppen har inga undergrupper.',
        subjectsCount: '{{length}} användare',
        agentsCount: '{{length}} administratörer',
        seeWholeGroup: 'Se hela gruppen',
      },

      singleOrganization: {
        editOrganization: 'Ändra organization',
        downloadReportsHeading: 'Ladda ner rapporter',
        startDate: 'Startdatum',
        endDate: 'Slutdatum',
        ibacsHeading: 'iBac enheter som är kopplade till denna organisationen',
        noIbacsInOrganization: 'Inga iBac enheter är kopplade till denna organisationen.',
        noActiveIbacsInOrganization: 'Inga aktiva iBac-enheter är anslutna till den här organisationen.',
        noInactiveIbacsInOrganization: 'Inga inaktiva iBac-enheter är anslutna till den här organisationen.',
        ibacUsageReport: 'iBac användning',
        subjectUsageReport: 'Användares användning',
        activeOffenders: 'Aktiva interner/användare',
        fieldUnitsStatusReport: 'Statusrapport för fältenheter',
        endOfProgramReport: 'Slut på programrapporten',
        activatedIBacUnits: 'Aktiverad iBac-enhetrapport',
        ibacAssignmentHistory: "iBacs tilldelningshistorik",
        startOfProgramSubjects: "Start av programrapport",
        currentIbacStatus: "iBac aktuell status",
        subjectStatusReport: 'Ämnesstatus',
        subjectDeviceAssignmentHistory: 'Ämnesenhetens tilldelningshistorik',
        includeOptionalSample: "Inkludera frivilliga alkoholprover"
      },

      singleRuleSet: {
        editRuleSet: 'Ändra inställningsmallen',
      },

      singleSchedule: {
        editSchedule: 'Ändra schemaläggningsmallen',
      },

      singleSubGroup: {
        subGroupInMainGroupHeading: '{{name}} i',
        editSubGroup: 'Ändra undergruppen',
        agentsHeading: '{{length}} administratörer',
        showProfile: 'Visa profilen',
        subjectsHeading: '{{length}} användare',
      },

      singleSubject: {
        subjectFirstNameHasNeverUsedTheMobileApp: '{{firstName}} har aldrig använt mobil appen.',
        firstLoginNotice: 'Inga schemalagda tester kommer att skapas förrän inloggningen till appen sker för första gången.',
        instantNewTest: 'Omedelbart nytt test',
        editSubject: 'Ändra på användaren',
        showSamplesChart: 'Visa Diagram',
        immediateTestSuccess: 'Ett nytt test har skapats och en notifikation har skickats till {{firstName}}.',
        scheduledTestsHeading: 'Schemalagda tester',
        scheduledTestsArePaused: 'Schemalagda tester är pausade',
        editTheSubjectToResumeTheScheduledTests: 'Ändra på användarens inställningar för att återuppta schemalagda tester.',
        subjectFirstNameDoesntHaveAnyScheduledTestsYet: '{{firstName}} har inte haft några schemalagda tester än.',
        optionalAlcoholSamplesHeading: 'Frivilliga alkoholprover',
        subjectFirstNameDoesntHaveAnyOptionalAlcoholSamplesYet: '{{firstName}} har inte lämnat in några frivilliga alkoholprov än.',
        messagesHeading: 'SMS-meddelanden',
        subjectFirstNameHasNotReceivedAnyMessagesYet: '{{firstName}} har ännu inte fått några SMS-meddelanden.',
        newSmsMessage: 'Nytt SMS meddelande',
        notesHeading: 'Anteckningar',
        messageAuthor: 'Avsändare',
        noteAuthor: 'Skapad av',
        sent: 'Skickades',
        created: 'Skapades',
        edit: 'Ändra',
        saveNote: 'Spara anteckning',
        cancel: 'Avbryt',
        addNoteHeading: 'Lägg till anteckning',
        saveNote: 'Spara anteckning',
        savingNote: 'Sparar anteckning…',
        settingsHeading: 'iBac inställningar',
        scheduleHeading: 'Schema',
        subjectFirstNameDoesntHaveAnySchedules: '{{firstName}} har inga scheman.',
        externalMonitorsHeading: 'Externa övervakare',
        subjectNoExternalMonitors: '{{firstName}} har inga externa övervakare.',
        agents: 'Administratörer',
        subjectNoAgents: '{{firstName} har inga administratörer.',
        subjectUsage: "Användares användning rapport",
        resetPassword: 'Återställer lösenordet',
        deleteSubject: 'TA BORT',
      },

      templates: {
        heading: "Mallar",
        menuItems: {
          schedule: 'Schemaläggningsmallar',
          settings: 'Inställningsmallar',
        },
      },

      mfa: {
        two_factor: "Tvåfaktorsautentisering",
        setup_prompt: "Ställ in tvåfaktorautentisering för ditt konto.",
        enable_now: "Gör det möjligt",
        skip: "Hoppa över",
        mfa_code_sent: "Autentiseringskoden skickades till din mobiltelefon.",
        enter_mfa_code: "Ange autentiseringskod:",
        verify: "Kontrollera",
        failedToEnableMfa: "Tvåfaktorsautentisering misslyckades"
      }
    },

    weekdays: {
      'MON': 'Måndag',
      'MON.short': 'Mån',
      'TUE': 'Tisdag',
      'TUE.short': 'Tis',
      'WED': 'Onsdag',
      'WED.short': 'Ons',
      'THU': 'Torsdag',
      'THU.short': 'Tors',
      'FRI': 'Fredag',
      'FRI.short': 'Fre',
      'SAT': 'Lördag',
      'SAT.short': 'Lör',
      'SUN': 'Söndag',
      'SUN.short': 'Sön'
    },

    states: {
      'active': 'AKTIV',
      'inactive': 'INAKTIV',
      'tampered': 'MANIPULERAD'
    },

    ibacFilter: {
      'all': 'Alla enheter ',
      'active': 'Aktiva enheter',
      'inactive': 'Inaktiva enheter',
      'tampered': 'Skadade enheter'
    },

    organizationFilter: {
      'all': 'Alla organisationer',
      'active': 'Aktiva organisationer',
      'inactive': 'Inaktiva organisationer'
    },

    alertFilter: {
      'all': 'Alla',
      'alerts': 'Varningar',
      'violations': 'Överträdelser'
    },

    violation: {
      optional_sample: "Valfritt test misslyckades",
      test_expired: "Test löper ut",
      test_failed: "Test misslyckas",
      liveness_error: "Fel vid alkoholprov - fel vid ansiktsigenkänning"
    },

    alert: {
      ibac_tampered: "iBac manipulerad",
      ibac_battery: "Låg iBac batteri",
      ibac_calibration: "iBac-kalibrering behövs",
      face_recognition: 'Ansiktsigenkänning misslyckades'
    },

    paging: {
      per_page_amount: "Resultat per sida",
      date_from_clean: "Rent datum från",
      date_to_clean: "Rent datum till"
    },

    frsFailReason: {
      WRONG_COLOR: 'Fel iBac-färg upptäckt',
      NO_FACES_TESTED_IMAGE: "Inget ansikte hittades på fotot",
      NO_FACES_PROFILE_PICTURE: 'Inget ansikte hittades på profilbilden',
      ONLY_SMALL_FACES: 'Ansiktet på bilden är för litet',
      SUBJECT_DETECTED_MULTIPLE_TIMES: 'Motivet upptäcktes flera gånger på fotot',
      NO_SUBJECT_DETECTED: 'Motivet hittades inte på fotot',
      NO_IBAC_DETECTED: 'Ingen iBac-enhet upptäcktes på fotot',
      DEVICE_SUBJECT_NO_OVERLAP: 'iBac-enheten finns inte i motivets mun',
      INVALID_IBAC_POSITION: 'iBac-enheten är felplacerad',
      MULTIPLE_FACES_DETECTED: 'Flera ansikten har upptäckts på fotot',
      UNKNOWN: 'Fel vid ansiktsigenkänning',
    },

    alcosystemsFailReason: {
      FACE_SPOOFING: 'En liveness-kontroll kunde inte utföras',
      NO_FACES: 'Inget ansikte hittades på fotot',
      MULTIPLE_SUBJECTS: 'Flera ansikten hittades på fotot',
      SMALL_FACES: 'Ansiktet på fotot är för litet',
      FACES_NEAR_BORDER: 'Subjektets ansikte är för nära ramens gränser',
      FOUND_MULTIPLE_SUBJECTS: 'Flera ansikten har upptäckts på fotot',
      SUBJECT_NOT_RECOGNIZED: 'Motivet hittades inte på fotot',
      MULTIPLE_IBACS: 'Flera iBac-enheter upptäcktes på fotot',
      NO_IBACS: 'Ingen iBac-enhet upptäckt på fotot',
      IBAC_NEAR_BORDERS: 'iBac-enheten är för nära bildgränsen',
      IBAC_WRONG_COLOR: 'Fel iBac-färg har upptäckts',
      IBAC_CANT_CONFIRM_POSITION: "Kunde inte bekräfta att personen blåser i iBac-enheten",
    },

    frsResult: {
      PASSED: "GODKÄND",
      FAILED: "MISSLYCKAD",
    },

    livenessError: {
      FACE_ANGLE_TOO_LARGE: 'Ansiktet på bilden är för stort.',
      FACE_CLOSE_TO_BORDER: 'Ansiktet är för nära en eller flera bildgränser',
      FACE_CROPPED: 'Ansiktet är beskuret på bilden',
      FACE_NOT_FOUND: 'Inget ansikte har upptäckts i bilden',
      FACE_TOO_CLOSE: 'Ansiktet på bilden är för nära',
      FACE_TOO_SMALL: 'Ansiktet på bilden är för litet',
      TOO_MANY_FACES: 'För många ansikten upptäckta',
      FACE_IS_OCCLUDED: 'Ansiktet på bilden är ockluderat',
      UNKNOWN: 'Fel vid ansiktsigenkänning',
      LIVENESS_FAILED: 'Inget levande ansikte upptäcktes på bilden'
    }

  })
